import { render, staticRenderFns } from "./PazarSherkati.vue?vue&type=template&id=2849db4e"
import script from "./PazarSherkati.vue?vue&type=script&lang=js"
export * from "./PazarSherkati.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports